import { bemComponent } from '@99designs/common/utils/app';
import * as React from 'react';

interface Props {
    variations?: string[];
    [key: string]: any;
}

interface CardInterface extends React.ForwardRefExoticComponent<Props> {
    Block: React.ComponentType<Props>;
    Media: React.ComponentType<Props>;
    Header: React.ComponentType<Props>;
    Icon: React.ComponentType<Props>;
}

const Card = bemComponent('card', 'Card') as CardInterface;

Card.Block = bemComponent('card__block', 'Card.Block');
Card.Media = bemComponent('card__media', 'Card.Media');
Card.Header = bemComponent('card__header', 'Card.Header');
Card.Icon = bemComponent('card__icon', 'Card.Icon');

export default Card;
